// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.percentages-among-relationship{padding-right:1%}.action-column{text-align:center !important;width:200px !important}.action-button{background:#f08e13;border-radius:5px;width:100px;height:37px;border:none;color:#fff}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
